HorizontalScroll = function(nVisibleItems, scrollEvent) {
    this.div = jQuery('#div-hs');
    this.scroll = this.div.find('.scroll-hs');
    this.container = this.div.find('.container-hs');
    this.items = this.container.find('.item-hs');
    this.nVisibleItems = nVisibleItems || 3;
    this.scrollEvent = scrollEvent || function() {};
    this.scrollBar = null;
    this.updateWidthContainer();
    Scrollbar.use(ScaleDeltaPlugin);
    this.scrollBarActivate();
    this.resizeEvent();
    return this;
};

HorizontalScroll.prototype.updateWidthContainer = function ()  {

    var paddingLeft = parseInt(this.container.css('padding-left'));
    var paddingRight = parseInt(this.container.css('padding-right'));

    var withItem = ( this.div.width() - paddingLeft )/this.nVisibleItems;
    var widthTotal = withItem * this.items.length + (paddingLeft + paddingRight);
    this.container.css({'width':widthTotal});

};

HorizontalScroll.prototype.resizeEvent = function ()  {
    jQuery( window ).resize(function() {
        this.updateWidthContainer();
    }.bind(this));
};

HorizontalScroll.prototype.scrollBarActivate = function ()  {

    this.scrollBar = Scrollbar.init(document.getElementById('scroll-div-hs'), {alwaysShowTracks:false});

    this.scrollBar.addListener(function() {
        requestAnimationFrame(function() {
            var delta = ( (this.scrollBar.offset.x * 100 / this.scrollBar.limit.x) / 100 ).toFixed(2);
            this.scroll.find('.scrolling-bar-hs span').css({transform: "scaleX(" + delta + ")"});
            this.scrollEvent();
        }.bind(this));
    }.bind(this));

}

/***  PLUGIN for: https://github.com/idiotWu/smooth-scrollbar/ */

function ScaleDeltaPlugin() {
    Scrollbar.ScrollbarPlugin.apply(this, arguments);
}

ScaleDeltaPlugin.prototype = Object.create(Scrollbar.ScrollbarPlugin.prototype);
ScaleDeltaPlugin.prototype.transformDelta = function(delta, fromEvent) {
    if (fromEvent.type == 'touchmove' || fromEvent.type == 'touchend') return;
    return deltaTransformation = {
        x: delta.y,
        y: delta.x
    };
};

ScaleDeltaPlugin.pluginName = 'scaleDelta';
ScaleDeltaPlugin.defaultOptions = {
    nothing: [],
};

